function Footer() {
  return (
    <>
      <footer>
        <div>
          Designed & developed with &#10084; by »
          <a href="https://kayacuneyt.com" target="_blank" rel="noreferrer">
            Cüneyt Kaya
          </a>
          »
        </div>
      </footer>
      <section
        style={{
          textAlign: "center",
          textDecoration: "none",
          fontSize: "12px",
        }}
      >
        <a
          style={{
            color: "inherit",
            textDecoration: "none",
          }}
          href="#top"
        >
          quickmailnk.com
        </a>
      </section>
    </>
  );
}

export default Footer;
